var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.3615a02ca873705965638ff370449edb.svg#n';
                    var viewUrl = 'sprites.3615a02ca873705965638ff370449edb.svg#view-n';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 17 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };